import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { login } from '../store/authSlice.js';
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(login({ email, password })).unwrap();
      toast.success("Logged in");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err || "Login failed");
    }
  };

  return (
    <div
      className="container-fluid vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <div
        className="card border-0 shadow-lg p-5 rounded-5"
        style={{ maxWidth: "450px", width: "100%" }}
      >
        <h2 className="fw-bold text-center mb-2">Admin Login</h2>
        <p className="text-muted text-center mb-4">
          Access your admin dashboard
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-bold">Email</label>
            <input
              type="email"
              className="form-control rounded-pill px-4 py-3"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label fw-bold">Password</label>
            <input
              type="password"
              className="form-control rounded-pill px-4 py-3"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            className="btn btn-dark w-100 rounded-pill py-3 fw-bold mb-3"
            style={{ background: "#2f0f0c" }}
          >
            Login
          </button>
        </form>

        <hr className="my-3" />

        <p className="text-center small mb-0">
          Don't have an account?{" "}
          <Link to="/admin/signup" className="fw-bold">
            Sign up here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
